<template>
    <div>
        <div class="row mb-2">
            <div class="col-md-8">
                <filter-global-input />
            </div>
            <div class="col-md-4">
                <export-button />
            </div>
        </div>
        <div class="card">
            <div class="card-body card-table">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                        enabled: true,
                        nextLabel: $t('table.NextLabel'),
                        prevLabel: $t('table.PrevLabel'),
                        rowsPerPageLabel: $t('table.RowsPerPageLabel'),
                        ofLabel: $t('table.OfLabel'),
                        pageLabel: $t('table.PageLabel'),
                        allLabel: $t('table.AllLabel')
                    }"
                        :rows="table.rows"
                        :sort-options="{
                            enabled: true,
                          }"
                        :styleClass="'table'+((!isCLoading) ? ' table-hover' : '')"
                        :totalRows="table.totalRecords"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        mode="remote"
                        ref="measurementsTable">
                    <template slot="table-column"
                              slot-scope="props">{{ $t('measurement.'+props.column.label) }}
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <control-date-badge
                                :controlDate="props.row.next_measurement"
                                v-if="props.column.field == 'next_measurement' && props.row.next_measurement">
                        </control-date-badge>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                    </template>
                    <div slot="emptystate">
                        <span v-if="isCLoading">
                            <loader-table></loader-table>
                        </span>
                        <span v-else>
                            {{$t('table.NoData')}}
                        </span>
                    </div>
                    <template slot="loadingContent">
                        <div class="spinner-border text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table'
    import {mapActions, mapGetters} from 'vuex'
    import loaderTable from '@/components/charts/loaders/loader-table.vue'
    import ExportButton from '@/components/ExportButton'
    import FilterGlobalInput from '@/components/FilterGlobalInput'
    import ControlDateBadge from '@/components/ControlDateBadge'

    export default {
        name: 'userIndex',
        data() {
            return {
                isLoading: false,
                isCLoading: true,
                showFilter: false,
                filterForm: {
                    number: '',
                    name: '',
                    control_date: ''
                },
                columns: [
                    {
                        label: 'Component',
                        field: 'number'
                    },
                    {
                        label: 'Customer',
                        field: 'relations.customer.name'
                    },
                    {
                        label: 'Date',
                        field: 'next_measurement'
                    }
                ]
            };
        },
        computed: {
            ...mapGetters({
                table: 'TABLE',
            })
        },
        components: {
            VueGoodTable,
            loaderTable,
            ExportButton,
            FilterGlobalInput,
            ControlDateBadge
        },
        async mounted() {
            this.$store.dispatch('TO_DEFAULTSTATE')
            this.defaultSort()
            await this.loadItems()
            this.isCLoading = false
        },
        methods: {
            hide: function () {
                this.showFilter = false

            },
            show: function () {
                this.showFilter = true
            },
            ...mapActions({
                    loadItems: 'GET_CONTROL',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },
            onSortChange(params) {
                let type = params[0].type
                let field = params[0].field

                switch (field) {
                    case 'relations.customer.name':
                        field = 'name'
                        break
                    case 'relations.component.number':
                        field = 'number'
                        break
                }

                this.updateParams({
                    sort: [{
                        type: type,
                        field: field,
                    }],
                });
                this.loadItems();
            },
            defaultSort() {
                this.updateParams({
                    sort: [{
                        type: '',
                        field: 'next_measurement',
                    }],
                });
            },
            async onColumnFilter() {
                this.isLoading = true
                this.updateParams({filter: this.filterForm});
                await this.loadItems();
                this.isLoading = false
            },
        }
    }
</script>
<style>
    .badge-measurement {
        font-size: 14px;
    }
</style>
